(function () {
  var root = document.querySelector('[data-tjr]');
  if (!root) return;
  var form = root.querySelector('[data-tjr-form]');
  if (!form) return;
  var cta = form.querySelector('[data-cta]');
  var alertBox = form.querySelector('[data-alert]');
  var sticky = root.querySelector('[data-sticky]');
  var busy = false;
  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var I = window.TJR_I18N || {};
  var MSG = {
    network: I.network || 'We couldn’t reach the store. Check your connection and try again.',
    generic: I.generic || 'Something went wrong. Please try again, or contact us if it keeps happening.',
    fields: I.fields || 'Please fill in the highlighted details.',
    date: I.date || 'Please choose a travel date for every trip before you continue.',
    empty: I.empty || 'Your booking has expired or is empty. Please choose your trip again.',
    confirmRemove: I.confirmRemove || 'Remove this trip from your booking?'
  };

  function showAlert(text) {
    alertBox.textContent = text;
    alertBox.hidden = !text;
  }
  function setBusy(on, el) {
    busy = on;
    (el || cta).classList.toggle('is-busy', on);
    cta.setAttribute('aria-busy', on ? 'true' : 'false');
    cta.disabled = on;
    root.querySelectorAll('[data-qty],[data-remove]').forEach(function (b) { b.disabled = on || b.hasAttribute('data-min'); });
  }

  // ---- field validation
  function fieldValid(input) {
    if (input.type === 'checkbox') return !input.required || input.checked;
    var v = (input.value || '').trim();
    if (input.required && !v) return false;
    if (input.type === 'number' && v) {
      var n = Number(v);
      if (!isFinite(n) || n < Number(input.min || 1) || n > Number(input.max || 999)) return false;
    }
    if (input.autocomplete === 'name' || /Traveller \d+ name/.test(input.name)) {
      if (v && v.replace(/[^\p{L}]/gu, '').length < 2) return false;
    }
    return true;
  }
  function mark(input, ok) {
    var err = document.getElementById(input.getAttribute('aria-describedby') || '');
    input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    if (err) err.hidden = ok;
    var det = input.closest('details');
    if (det) {
      var done = det.querySelector('[data-done]');
      if (done) done.hidden = !(ok && input.value.trim());
      if (!ok) det.open = true;
    }
  }
  function validateAll() {
    var first = null;
    form.querySelectorAll('input[required], textarea[required]').forEach(function (i) {
      var ok = fieldValid(i);
      mark(i, ok);
      if (!ok && !first) first = i;
    });
    return first;
  }
  form.addEventListener('blur', function (e) {
    var t = e.target;
    if (t.matches && t.matches('input[required]') && (t.value || t.type === 'checkbox')) mark(t, fieldValid(t));
    if (t.matches && t.matches('input, textarea')) queueSave();
  }, true);
  form.addEventListener('input', function (e) {
    var t = e.target;
    if (t.getAttribute && t.getAttribute('aria-invalid') === 'true' && fieldValid(t)) mark(t, true);
  });
  form.addEventListener('change', function (e) {
    if (e.target.type === 'checkbox') { mark(e.target, fieldValid(e.target)); queueSave(); }
  });

  // ---- save details to the cart (attributes + note)
  function collect() {
    var data = { attributes: {}, note: '' };
    form.querySelectorAll('[name^="attributes["]').forEach(function (i) {
      var key = i.name.slice(11, -1);
      data.attributes[key] = i.type === 'checkbox' ? (i.checked ? 'Yes' : '') : i.value.trim();
    });
    var note = form.querySelector('[name="note"]');
    if (note) data.note = note.value.trim();
    return data;
  }
  var saveTimer = null;
  function queueSave() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () { save().catch(function () {}); }, 600);
  }
  function post(url, body) {
    return fetch(routes + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var e = new Error('http');
          e.userMessage = (j && (j.description || j.message)) || MSG.generic;
          throw e;
        }
        return j;
      });
    });
  }
  function save() { return post('cart/update.js', collect()); }

  // ---- quantity and remove
  function change(line, qty, btn) {
    if (busy) return;
    setBusy(true, btn);
    showAlert('');
    save()
      .catch(function () {})
      .then(function () { return post('cart/change.js', { line: Number(line), quantity: qty }); })
      .then(function () { window.location.reload(); })
      .catch(function (e) {
        setBusy(false, btn);
        showAlert(e.userMessage || MSG.network);
      });
  }
  root.querySelectorAll('.tjr-trip').forEach(function (card) {
    var line = card.getAttribute('data-line');
    var out = card.querySelector('.tjr-qty output');
    card.querySelectorAll('[data-qty]').forEach(function (b) {
      if (b.disabled) b.setAttribute('data-min', '');
      b.addEventListener('click', function () {
        var q = Number(out.textContent) + Number(b.getAttribute('data-qty'));
        if (q < 1) return;
        change(line, q, b);
      });
    });
    var rm = card.querySelector('[data-remove]');
    if (rm) rm.addEventListener('click', function () {
      if (window.confirm(MSG.confirmRemove)) change(line, 0, rm);
    });
  });

  // ---- continue to checkout
  function go(e) {
    if (e) e.preventDefault();
    if (busy) return;
    showAlert('');
    if (form.querySelector('[data-date-block]')) {
      showAlert(MSG.date);
      alertBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var bad = validateAll();
    if (bad) {
      showAlert(MSG.fields);
      bad.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { bad.focus({ preventScroll: true }); }, 350);
      return;
    }
    setBusy(true);
    save()
      .then(function () {
        return fetch(routes + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (c) {
        if (!c || !c.item_count) {
          setBusy(false);
          showAlert(MSG.empty);
          return;
        }
        var shown = form.querySelector('[data-total]');
        var shownCents = shown ? Number(shown.getAttribute('data-cents') || NaN) : NaN;
        if (isFinite(shownCents) && shownCents !== c.total_price) {
          window.location.reload();
          return;
        }
        window.location.href = routes + 'checkout';
      })
      .catch(function (err) {
        setBusy(false);
        showAlert(err.userMessage || MSG.network);
      });
  }
  form.addEventListener('submit', go);
  if (sticky) {
    var goBtn = sticky.querySelector('[data-sticky-go]');
    goBtn.addEventListener('click', go);
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) setBusy(false); });

  // ---- mobile sticky bar: show only while the main button is off screen and no field is focused
  if (sticky && 'IntersectionObserver' in window) {
    var wrap = form.querySelector('[data-cta-wrap]');
    var ctaVisible = false;
    var typing = false;
    var mq = window.matchMedia('(max-width: 899px)');
    function upd() { sticky.hidden = !mq.matches || ctaVisible || typing; root.classList.toggle('has-sticky', !sticky.hidden); }
    new IntersectionObserver(function (en) { ctaVisible = en[0].isIntersecting; upd(); }, { rootMargin: '0px 0px -40px 0px' }).observe(wrap);
    form.addEventListener('focusin', function (e) { if (e.target.matches('input, textarea')) { typing = true; upd(); } });
    form.addEventListener('focusout', function () { typing = false; setTimeout(upd, 150); });
    if (mq.addEventListener) mq.addEventListener('change', upd);
    upd();
  }
})();
